(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('Facility', Facility);

    Facility.$inject = ['$resource', 'urls', 'httpMethods'];
    function Facility($resource, urls, httpMethods) {
        return $resource('', { id: '@id' }, {
            search: { url: urls.facilitySearch, method: httpMethods.get, allowAnonymous: true }
        });
    }
})();